<template>
  <div class="contaier">
    <div class="top-nvb_box">
      <div class="top-nvb">
        <div class="logo-box" @click="toHome">
          <img alt="" class="img" src="../assets/img/logo.png" />
        </div>
        <span class="lang" @click="changeLanguage($i18n.locale)">{{
          $t("home.lang")
        }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { EventBus } from "@/assets/js/event-bus";
export default {
  name: "HeadPage",
  methods: {
    changeLanguage(lang) {
      console.log("changelang :>> ", lang);
      let lang_ = lang === "zh" ? "en" : "zh";
      this.$i18n.locale = lang_;
      EventBus.$emit("message", lang);
      if (lang_ === "zh") {
        let { v } = this.$route?.query;
        let query_ = { lang: "zh" };
        if (v) {
          query_.v = v;
        }
        this.$router.push({ path: this.$route.path, query: query_ }).catch((data) => {
          console.log("data :>> 3", data);
        });
      } else {
        let { v } = this.$route?.query;
        let query_ = { lang: "en" };
        if (v) {
          query_.v = v;
        }
        this.$router.push({ path: this.$route.path, query: query_ }).catch((data) => {
          console.log("data :>>4 ", data);
        });
      }
    },
    toHome() {
      this.$router
        .push({ path: "/survey", query: { lang: this.$i18n.locale } })
        .catch((data) => {
          console.log("data :>>4 ", data);
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.contaier {
  padding-top: 61px;
  .top-nvb_box {
    width: 100%;
    position: fixed;
    left: 0;
    top: 0;
    border-bottom: #ccc solid 1px;
    background-color: #fff;
    z-index: 1000;
    .top-nvb {
      position: relative;
      max-width: 1200px;
      margin: 0 auto;
      padding: 20px 0;
      .logo-box {
        max-width: 120px;
        margin: 0 auto;
        cursor: pointer;
      }
      .lang {
        position: absolute;
        top: 50%;
        right: 15px;
        transform: translate(0%, -50%);
        cursor: pointer;
        text-decoration: underline;
      }
    }
  }
}
</style>
